export const manufacturingFr = {
  title: 'Ordres de fabrication',
  subtitle:
    'Planifier les recettes approuvées, consommer par lot et déclarer la production avec une piste d’audit complète.',
  help: {
    open: 'Ouvrir l’aide des ordres de fabrication',
    detail: 'Ouvrir l’aide sur la planification, les mouvements et la déclaration',
  },
  actions: {
    new: 'Nouvel ordre',
    plan: 'Planifier',
    release: 'Libérer',
    reserve: 'Réserver les matières',
    start: 'Démarrer',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    reportComplete: 'Déclarer terminé',
    close: 'Clôturer',
    cancel: 'Annuler',
    issue: 'Sortir',
    return: 'Retourner',
    confirmStep: 'Confirmer',
    comment: 'Commentaire',
    post: 'Comptabiliser',
  },
  filters: {
    search: 'Rechercher numéro, article ou besoin',
    status: 'Statut',
    allStatuses: 'Tous les statuts',
    priority: 'Priorité',
    allPriorities: 'Toutes les priorités',
    from: 'Début à partir du',
    to: 'Début jusqu’au',
  },
  statuses: {
    DRAFT: 'Brouillon',
    PLANNED: 'Planifié',
    RELEASED: 'Libéré',
    MATERIAL_RESERVED: 'Matières réservées',
    IN_PRODUCTION: 'En production',
    PAUSED: 'En pause',
    REPORTED_COMPLETE: 'Déclaré terminé',
    CLOSED: 'Clôturé',
    CANCELLED: 'Annulé',
  },
  priorities: { LOW: 'Basse', NORMAL: 'Normale', HIGH: 'Haute', URGENT: 'Urgente' },
  columns: {
    number: 'Ordre',
    product: 'Produit fini',
    status: 'Statut',
    priority: 'Priorité',
    recipe: 'Recette',
    planned: 'Prévu',
    produced: 'Produit',
    start: 'Début',
    updated: 'Modifié',
    position: 'Pos.',
    material: 'Matière',
    reserved: 'Réservé',
    issued: 'Sorti',
    returned: 'Retourné',
    scrap: 'Rebut',
    variance: 'Écart',
    step: 'Opération',
    workCenter: 'Poste de travail',
    duration: 'Durée (min)',
    input: 'Entrée',
    output: 'Sortie',
    type: 'Type',
    batch: 'Lot',
    quantity: 'Quantité',
  },
  empty: 'Aucun ordre de fabrication trouvé.',
  editor: {
    newTitle: 'Créer un ordre de fabrication',
    subtitle: 'Le calcul serveur détermine les besoins depuis une recette et une gamme approuvées.',
    plan: 'Base de planification',
    planDescription:
      'Définissez la source, la quantité, les dates, les magasins et les responsables. Les brouillons utilisent un verrou optimiste.',
  },
  fields: {
    recipe: 'Recette approuvée',
    routing: 'Gamme approuvée',
    plannedQuantity: 'Quantité prévue',
    unit: 'Unité',
    priority: 'Priorité',
    salesOrder: 'Commande client',
    plannedStart: 'Début prévu',
    plannedEnd: 'Fin prévue',
    sourceWarehouse: 'Magasin de prélèvement',
    targetWarehouse: 'Magasin cible',
    internalDemand: 'Besoin interne',
    responsibleUsers: 'Responsables',
    note: 'Note / motif',
    postingType: 'Type de mouvement',
    quantity: 'Quantité',
    reason: 'Motif',
    stepResult: 'Résultat',
    inputQuantity: 'Quantité d’entrée',
    outputQuantity: 'Quantité de sortie',
    scrapQuantity: 'Quantité rebutée',
    duration: 'Durée réelle (min)',
    qualityChecks: 'Contrôles qualité obligatoires',
    producedQuantity: 'Quantité produite',
    batchNumber: 'Nouveau numéro de lot',
    bestBefore: 'Date de durabilité minimale',
  },
  shortage: {
    title: 'Manque de matière',
    description: '{{count}} poste(s) ne peuvent pas être entièrement couverts par le stock libre.',
  },
  tabs: {
    materials: 'Matières et consommation',
    process: 'Processus et qualité',
    outputs: 'Sorties',
    history: 'Historique et commentaires',
    documents: 'Documents GED',
  },
  documents: { title: 'Dossier de production' },
  summary: {
    planned: 'Quantité prévue',
    produced: 'Produit',
    scrap: 'Rebut',
    yield: 'Rendement réel',
    plannedCost: 'Coût matière prévu',
    actualCost: 'Coût matière réel',
  },
  materials: {
    title: 'Postes matière',
    description:
      'Besoins, réservations et mouvements par lot restent séparés et utilisent des décimales exactes.',
  },
  process: {
    title: 'Déclarations de processus',
    description: 'Les opérations, paramètres et contrôles proviennent de l’instantané approuvé.',
  },
  stepStatuses: {
    PENDING: 'Ouvert',
    IN_PROGRESS: 'En cours',
    COMPLETED: 'Terminé',
    SKIPPED: 'Ignoré avec motif',
  },
  outputs: {
    title: 'Sorties et lots produits',
    description: 'Produits finis, sous-produits et rebuts de la déclaration.',
    empty: 'Aucune sortie comptabilisée.',
  },
  outputTypes: { FINISHED_GOOD: 'Produit fini', BYPRODUCT: 'Sous-produit', SCRAP: 'Rebut' },
  history: {
    title: 'Historique immuable',
    description:
      'Chaque opération conserve clé d’idempotence, empreinte, utilisateur et horodatage.',
  },
  comments: {
    title: 'Commentaires',
    description: 'Notes en ajout seul dans le dossier audité.',
    empty: 'Aucun commentaire.',
  },
  operationTypes: {
    CREATE: 'Créé',
    UPDATE: 'Brouillon modifié',
    PLAN: 'Planifié',
    RELEASE: 'Libéré',
    RESERVE: 'Réservé',
    ISSUE: 'Matière sortie',
    RETURN: 'Matière retournée',
    START: 'Démarré',
    PAUSE: 'Mis en pause',
    RESUME: 'Repris',
    STEP_CONFIRM: 'Étape confirmée',
    REPORT_COMPLETE: 'Déclaré terminé',
    CLOSE: 'Clôturé',
    CANCEL: 'Annulé',
    COMMENT: 'Commentaire ajouté',
  },
  workflow: {
    plan: {
      title: 'Planifier l’ordre',
      description:
        'L’instantané est figé; les changements structurels ne sont ensuite plus possibles.',
    },
    release: {
      title: 'Libérer l’ordre',
      description: 'Les sources approuvées et les besoins prévus deviennent la base obligatoire.',
    },
    start: {
      title: 'Démarrer la production',
      description: 'Le début réel est enregistré et les sorties par lot restent traçables.',
    },
    pause: {
      title: 'Mettre en pause',
      description: 'L’ordre reste comptabilisable mais apparaît en pause.',
    },
    resume: {
      title: 'Reprendre la production',
      description: 'L’ordre revient en production active.',
    },
    close: {
      title: 'Clôturer l’ordre',
      description: 'Les réservations ouvertes sont libérées et l’ordre devient immuable.',
    },
  },
  reserve: {
    title: 'Réserver automatiquement le stock libre',
    description: 'La sélection est transactionnelle selon FEFO/FIFO; les manques restent visibles.',
  },
  materialDialog: {
    ISSUE: { title: 'Comptabiliser une sortie' },
    SCRAP: { title: 'Comptabiliser un rebut matière' },
    RETURN: { title: 'Comptabiliser un retour' },
  },
  materialActions: { ISSUE: 'Sortie', SCRAP: 'Rebut', RETURN: 'Retour' },
  quality: { PASS: 'Conforme', FAIL: 'Non conforme', NOT_CHECKED: 'Non contrôlé' },
  stepDialog: { title: 'Confirmer l’étape de processus' },
  report: {
    title: 'Déclarer la production terminée',
    description: 'Le lot produit et les entrées de stock sont créés dans une seule transaction.',
  },
  cancel: {
    title: 'Annuler l’ordre de fabrication',
    description: 'Un motif est obligatoire et toute consommation réelle doit avoir été retournée.',
  },
  comment: {
    title: 'Ajouter un commentaire',
    description: 'L’entrée est conservée immuablement avec utilisateur et horodatage.',
  },
  messages: {
    created: 'Ordre de fabrication créé.',
    saved: 'Brouillon enregistré.',
    workflow: 'Statut mis à jour.',
    reserved: 'Matières disponibles réservées.',
    posted: 'Mouvement matière comptabilisé.',
    stepConfirmed: 'Étape confirmée.',
    completed: 'Production déclarée terminée.',
    cancelled: 'Ordre annulé.',
    commented: 'Commentaire ajouté.',
  },
} as const;
